import { render, staticRenderFns } from "./BgGrayText.vue?vue&type=template&id=7101a11b&scoped=true"
import script from "./BgGrayText.vue?vue&type=script&lang=js"
export * from "./BgGrayText.vue?vue&type=script&lang=js"
import style0 from "./BgGrayText.vue?vue&type=style&index=0&id=7101a11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7101a11b",
  null
  
)

export default component.exports